import { render } from "./MainWrapper.vue?vue&type=template&id=eda8a6ea"
import script from "./MainWrapper.vue?vue&type=script&lang=js"
export * from "./MainWrapper.vue?vue&type=script&lang=js"

import "./MainWrapper.vue?vue&type=style&index=0&id=eda8a6ea&lang=scss"

import exportComponent from "/data/www/shoptok-analytics/frontend/live/live_227/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__